/**
 * Breadcrumb components for routes with an ID in the path. Each shows a
 * readable name when one is cached or cheaply available, else the raw ID.
 * Feature areas can add their own (for example a template-name crumb).
 */
import { useQuery } from '@tanstack/react-query'
import { applicationQuery } from '@/api/queries/applications'

export function IdCrumb({ value }: { value: string | undefined }) {
  return <span className="font-mono text-xs">{value ?? '…'}</span>
}

/** Use as `staticData: { crumb: paramCrumb('templateId') }`. */
export function paramCrumb(param: string) {
  function ParamCrumb({ params }: { params: Record<string, string> }) {
    return <IdCrumb value={params[param]} />
  }
  ParamCrumb.displayName = `ParamCrumb(${param})`
  return ParamCrumb
}

export function ApplicationCrumb({ params }: { params: Record<string, string> }) {
  const id = params.appId ?? ''
  const q = useQuery({ ...applicationQuery(id), enabled: !!id })
  return q.data ? <span>{q.data.name}</span> : <IdCrumb value={id} />
}
